import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'
import { Button } from '@highlight/ui'

type FrameCtaProps = ComponentProps<typeof Button>

/** The flow's forward action: the system's 40px button, block, capped at the column's 308 measure. */
export function FrameCta({ className, ...props }: FrameCtaProps) {
  return <Button size="xl" block className={twMerge('mx-auto max-w-[308px]', className)} {...props} />
}
